var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"face"},[_vm._l((_vm.rows),function(row,rix){return _vm._l((row),function(color,cix){return _c('div',{staticClass:"cell",class:{ 'is-active-selection': _vm.isSelected(_vm.f, rix, cix) },style:({ backgroundColor: color }),on:{"click":function($event){return _vm.selectColor(_vm.f, rix, cix, $event)}}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }